<template>
  <div class="mt-n2">
    <b-card-header>
      <b-card-title class="mb-0">
        {{ titleTable }}
      </b-card-title>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="dialogExport = true"
        class="d-none d-sm-inline-flex"
      >
        <feather-icon icon="ArrowDownIcon" />
        Exportar
      </b-button>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="dialogExport = true"
        class="d-inline-flex d-sm-none"
      >
        <feather-icon icon="ArrowDownIcon" />
      </b-button>
    </b-card-header>
    <b-card-body class="mb-n4">
      <b-overlay
        :show="loading"
        :variant="isDarkMode ? 'dark' : 'light'"
      >
        <template v-slot:overlay>
          <loading-logo />
        </template>

        <b-table
          striped
          hover
          responsive
          :items="pagedData"
          :loading="loading"
          loading-text="Cargando..."
          class="position-relative"
        />
        <div
          v-if="pagedData.length === 0"
          class="d-flex align-items-center justify-content-center top-50 start-50 translate-middle"
        >
          <span class="text-muted">No hay datos disponibles.</span>
        </div>

        <div
          v-if="pagedData.length > 0"
          class="mx-2 mb-2"
        >
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de
                {{ dataMeta.of }} items
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>

                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>

      <!-- Modal export -->
      <b-modal
        v-model="dialogExport"
        title="Exportar datos"
        hide-footer
      >
        <export-data
          @close="close"
          @export="exportData"
        />
      </b-modal>
    </b-card-body>
    <!--</b-card>-->
  </div>
</template>

<script>
import {
  BTable,
  BPagination,
  BRow,
  BCol,
  BOverlay,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BButton,
  BModal,
} from 'bootstrap-vue'
import store from '@/store'
import exportFromJSON from 'export-from-json'
import ExportData from '@/views/utils/ExportData.vue'
import LoadingLogo from '../miscellaneous/LoadingLogo.vue'

export default {
  components: {
    BTable,
    BPagination,
    BRow,
    BCol,
    LoadingLogo,
    BOverlay,
    BCardBody,
    BCardTitle,
    BCardHeader,
    BButton,
    BModal,
    ExportData,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    titleTable: {
      type: String,
      default: 'Tabla de Datos',
    },
    perPage: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPageOptions: [5, 10, 15, 20],
      dialogExport: false,
    }
  },
  computed: {
    isDarkMode() {
      return store.state.appConfig.layout.skin === 'dark'
    },
    dataMeta() {
      if (this.items.length === 0) {
        return {
          from: 0,
          to: 0,
          of: 0,
        }
      }
      const from = (this.currentPage - 1) * this.perPage + 1
      const to = this.currentPage * this.perPage
      const of = this.items.length
      return { from, to: to > of ? of : to, of }
    },
    totalData() {
      return this.items.length
    },
    pagedData() {
      const startIndex = (this.currentPage - 1) * this.perPage
      const endIndex = startIndex + this.perPage
      return this.items.slice(startIndex, endIndex)
    },
  },
  methods: {
    close() {
      this.dialogExport = false
    },
    exportData() {
      const fileName = 'Listado de Datos'
      const exportType = exportFromJSON.types.xls
      exportFromJSON({ data: this.items, fileName, exportType })
      this.close()
    },
  },
}
</script>